import { render } from "./chatPage.vue?vue&type=template&id=0649b978&ts=true"
import script from "./chatPage.vue?vue&type=script&lang=ts"
export * from "./chatPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__